import { makeStyles } from '@material-ui/core';

export const useCircleStyles = makeStyles((theme) => ({
  parent: {
    maxWidth: (props) => (props.size ? props.size : '250px'),
    maxHeight: (props) => (props.size ? props.size : '250px'),
    position: 'relative',
    transform: 'scale(1.2, 1.2)',
  },
  inner: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
    verticalAlign: 'middle',
  },
}));
